export default "__VITE_ASSET__CmkTiREE__"